import { Config, ConfigItem } from '../types';

export const exportJson = (config: Config): void => {
    const exportConfig = {
        ...config,
        list: config.list.map((item, index) => ({
            ...item,
            id: index + 1
        }))
    };

    const jsonString = JSON.stringify(exportConfig, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'config.json';
    a.click();
    URL.revokeObjectURL(url);
};

export const importJson = (file: File): Promise<Config> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e: any) => {
            try {
                const imported = JSON.parse(e.target.result);
                if (imported.title && imported.type && imported.list_type && Array.isArray(imported.list)) {
                    // Ensure unique IDs for imported items
                    const importedWithIds = {
                        ...imported,
                        list: imported.list.map((item: ConfigItem, index: number) => ({
                            ...item,
                            id: Date.now() + index
                        }))
                    };
                    resolve(importedWithIds);
                } else {
                    reject(new Error('ساختار فایل JSON معتبر نیست'));
                }
            } catch (error) {
                reject(new Error('فایل JSON نامعتبر است'));
            }
        };
        reader.readAsText(file);
    });
};

export const validateNewItem = (item: { title: string; image: string; url: string }): boolean => {
    return !!(item.title && item.image && item.url);
}; 